import { useMemo } from 'react'

import { DxTradeCashTransactionTypes } from '@model/DxTrade.types'
import type { DxTradeOrder } from '@model/DxTrade.types'

export type HistoryOrderPnl = number | null

export const useHistoryOrderPnl = (order?: DxTradeOrder | null): HistoryOrderPnl => {
  return useMemo(() => {
    const cashTransactions = order?.cashTransactions ?? []
    if (!cashTransactions.length) return null

    const settlements = cashTransactions.filter(
      (tx) => tx.type === DxTradeCashTransactionTypes.SETTLEMENT
    )

    if (!settlements.length) return null

    const pnl = settlements.reduce((acc, tx) => acc + (tx.value ?? 0), 0)

    return pnl
  }, [order])
}
